import React from 'react';
import { UserRole } from "./types";
export var UserContext = /*#__PURE__*/React.createContext(undefined);
export var UserProvider = function UserProvider(_ref) {
  var value = _ref.value,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(UserContext.Provider, {
    value: value
  }, children);
};
export var useCurrentUser = function useCurrentUser() {
  var currentUser = React.useContext(UserContext);
  return [currentUser];
};
export { UserRole };